module.exports = {"id":"224367","name":"Germán Lanaro","rating":"72","photo":"./data/images/photos/2/224367.png","club":{"name":"Uni. Católica","logo":"./data/images/clubs/Uni.Catolica.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GermanLanaro0.json
// module id = 1569
// module chunks = 0